module.exports = __webpack_public_path__ + "img/falklandislands.40b20a7a.svg";